/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { JobFromJSON, JobToJSON } from './Job';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetJobsResponseDataFromJSON(json) {
    return GetJobsResponseDataFromJSONTyped(json, false);
}
export function GetJobsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        jobs: !exists(json, 'jobs') ? undefined : json['jobs'].map(JobFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetJobsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        jobs: value.jobs === undefined ? undefined : value.jobs.map(JobToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
